import { render, staticRenderFns } from "./index.vue?vue&type=template&id=daf3fb2c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./assets/index.css?vue&type=style&index=0&id=daf3fb2c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf3fb2c",
  null
  
)

export default component.exports